module.exports = __webpack_public_path__ + "static/media/GREEN.46baf671.png";